import { useEffect, useState } from 'react';

export const useResponsiveCanvasIos = (parentRect: DOMRect | null) => {
  // This hook calculates the Widht & Height of the selfie-screen canvas
  // depending on the width & height of the parent DIV

  // The max video size also limits the canvas

  // Size of the Frame images provided by the app;
  const ratio = 1080 / 1350;

  // Reference the Parent Container which defines the maximim Sizes
  const [canvasHeight, setCanvasHeight] = useState<number>(480);
  const [canvasWidth, setCanvasWidth] = useState<number>(2 / ratio);

  const setSize = () => {
    const paddingX = 2 * 30; // 30px padding to the left+right
    const paddingY = 30 + 250; // 30px padding top + 200 padding for controls

    if (parentRect) {
      const paddedWidth = parentRect.width - paddingX;
      const paddedHeight = parentRect.height - paddingY;
      const fillWidth = paddedWidth;
      const fillHeight = paddedWidth / ratio;

      if (fillHeight > paddedHeight) {
        setCanvasHeight(paddedHeight);
        setCanvasWidth(paddedHeight * ratio);
      } else {
        setCanvasWidth(fillWidth);
        setCanvasHeight(fillHeight);
      }
    }
  };

  useEffect(() => {
    setSize();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [parentRect]);

  return {
    width: canvasWidth,
    height: canvasHeight,
  };
};
